// extracted by mini-css-extract-plugin
export default {"tableHeaderBox":"StudentsPhotosTableHeader_tableHeaderBox__Ak9Fr","studentBox":"StudentsPhotosTableHeader_studentBox__TA6qg"};